"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
function RegularWrapper() {
    return ((0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'RegularWrapper_Content', children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, { "data-e2e": 'RegularWrapper_Outlet' }) }));
}
exports.RegularWrapper = RegularWrapper;
const Content = styled_components_1.default.div `
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
